import { AppBaseProps, CommonApp, Context, Entity } from "../../core/components/commonApp";
import { Helper } from "../../core/util/helper";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { NotificationHelper } from "../../core/util/notificationHelper";
import { Grid } from "../../core/components/grid";
import { Region } from "../../core/components/region";
import GridLayout, { BreakPoint, GridLayoutBreakPointConfig } from "../../core/components/gridLayout";
import { Config } from "../../core/config/config";
import { ToolBarStandardButton, ToolBarStandardButtonType } from "../../core/components/toolBar";
import { General } from "../../../siteManagement/general";
import { AppHelper } from "../../appHelper";
import { DialogHelper } from "../../core/util/dialogHelper";
import { StringKeyDictionary } from "../../commonInterfaces";
import React from "react";
export default class Units extends React.Component<any, UnitsState>{
    private translations: StringKeyDictionary<string>;
    private layoutConfig: GridLayoutBreakPointConfig[];
    constructor(props) {
        super(props)
        this.state = {
            quantities: [],
            selected: null
        }
        this.initApp();
    }

    private initApp = async () => {
        const result = await Promise.all([
            HTTPService.get<JsonResultClass<QuantityEntity[]>>("Unit/GetAllQuantities"),
            Helper.getTranslations([
                "Standard.Name", "WebSMS.GeneralSettings.Currency.Characters", "WebSMS.UserSettings.MainGroup.Iso",
                "WebSMS.Title.Allgemein", "WebSMS.GeneralSettings.Documents.AtLeastOneName", "Standard.BitteWählen",
                "Standard.Other", "WebSMS.GeneralSettings.Units.Units", "WebSMS.GeneralSettings.Units.BaseUnit",
                "WebSMS.GeneralSettings.Units.Quantity", "WebSMS.GeneralSettings.Units.ExternalId", "WebSMS.GeneralSettings.Units.SetAsBaseUnit",
                "WebSMS.GeneralSettings.Units.SaveAsBaseUnit", "WebSMS.GeneralSettings.Units.ShowMore", "WebSMS.GeneralSettings.Units.ShowLess",
                "WebSMS.GeneralSettings.Units.NewUnitOf", "WebSMS.GeneralSettings.Units.ReallyDeleteBaseUnit", "Standard.Msg.SpeichernErfolgreich",
                "WebSMS.GeneralSettings.Units.CommonCode", "WebSMS.GeneralSettings.Units.DefineAsBaseUnit", "WebSMS.GeneralSettings.Units.CommonCodeUnique",
                "WebSMS.GeneralSettings.Units.DownloadAsExcel"
            ])
        ]);
        this.layoutConfig = [
            {
                breakPoint: BreakPoint.ExtraLarge,
                size: "6/12"
            },
            {
                breakPoint: BreakPoint.Large,
                size: "6/12"
            },
            {
                breakPoint: BreakPoint.Medium,
                size: "6/12"
            },
            {
                breakPoint: BreakPoint.Small,
                size: "12/12"
            },
            {
                breakPoint: BreakPoint.ExtraSmall,
                size: "12/12"
            }
        ]
        this.translations = result[1].Data;
        if (result[0].Code == 0) {
            const data = result[0].Data;
            this.setState({
                quantities: data,
                selected: data.length > 0 ? data[0] : null
            })
        } else {
            NotificationHelper.showErrorMessage(result[0].Message)
            this.setState({})
        }
    }

    private onSelectionChange = (entity: QuantityEntity) => {
        this.setState({ selected: entity });
    }

    private onChange = (entity: QuantityEntity, callBack: () => void) => {
        if (!Helper.hasValue(callBack))
            callBack = () => { }
        const quantities = this.state.quantities;
        const index = quantities.findIndex(f => f.Id == entity.Id);
        if (index > -1) {
            entity.Units = UnitHelper.sortByDisplayName<UnitEntity>(entity.Units);
            quantities[index] = entity;
            $(window).trigger("unitsChanged");
            this.setState({
                selected: entity,
                quantities: quantities
            }, callBack);
        }
    }

    private updateQuantities = (quantities: QuantityEntity[], selected: QuantityEntity, callback: () => void) => {
        if (!Helper.hasValue(callback))
            callback = () => { }
        $(window).trigger("unitsChanged");
        setTimeout(() => {
            this.setState({
                quantities: UnitHelper.sortByDisplayName<QuantityEntity>(quantities),
                selected: selected
            }, callback)
        }, 1000)


        
    }

    private downloadExcel = () => {
        Helper.openInNewBrowserTab(Config.baseUrl + "Unit/Download");
    }

    render() {
        let commonCodes = [];
        this.state.quantities.forEach((quantity) => {
            if (!Helper.hasValue(quantity.Units))
                quantity.Units = [];
            commonCodes = commonCodes.concat(quantity.Units.map((unit) => { return unit.CommonCode }))
        })
        if (Helper.hasValue(this.translations)) {
            return (
                <>
                    <GridLayout config={[this.layoutConfig, this.layoutConfig]}>
                        <Region title={this.translations["WebSMS.GeneralSettings.Units.Quantity"]}>
                            <QuantityGrid
                                onSelectionChange={this.onSelectionChange}
                                quantities={this.state.quantities}
                                updateQuantities={this.updateQuantities}
                                translations={this.translations}
                            />
                        </Region>
                        <Region title={this.translations["WebSMS.GeneralSettings.Units.Units"]}>
                            <UnitGrid
                                entity={this.state.selected}
                                onChange={this.onChange}
                                translations={this.translations}
                                commonCodes={commonCodes}
                            />
                        </Region>
                    </GridLayout>
                    <FloatingsButtons onDownloadClick={this.downloadExcel} hoverText={this.translations["WebSMS.GeneralSettings.Units.DownloadAsExcel"]} />
                </>
            );
        } else {
            return null;
        }
    }
}

interface UnitsState {
    quantities: QuantityEntity[];
    selected: QuantityEntity;
}

class FloatingsButtons extends React.Component<FloatingsButtonsProps, any>{

    constructor(props) {
        super(props)
    }

    private createDownloadButton = () => {
        return (
            <div id={kendo.guid()} className="sheet__action" style={{ backgroundColor: "#1D6F42" }} onClick={this.props.onDownloadClick} title={this.props.hoverText}>
                <i className="fal fa-file-excel fa-fw fa-2x"></i>
            </div>
        );
    }

    render() {
        return (
            <div className="sheet__actions sheet__actions--active">
                {this.createDownloadButton()}
            </div>
        );
    }
}

interface FloatingsButtonsProps {
    hoverText: string;
    onDownloadClick: () => void;
}


class QuantityGrid extends React.Component<QuantityGridProps, QuantityGridState>{
    private gridOptions: kendo.ui.GridOptions;
    private buttons: Array<ToolBarStandardButton>;
    private metaData: any;

    constructor(props: QuantityGridProps) {
        super(props)
        let selectedEntity: QuantityEntity = null;
        if (props.quantities.length > 0) {
            selectedEntity = props.quantities[0];
        }
        this.state = {
            selectedEntity: selectedEntity
        }
        this.initApp();
    }

    private initApp = () => {
        this.gridOptions = {
            sortable: true,
            pageable: false,
            groupable: false,
            filterable: true,
            selectable: true,
            resizable: true,
            scrollable: true,
            columns: [
                {
                    field: "DisplayName",
                    title: this.props.translations["Standard.Name"]
                },
                {
                    title: this.props.translations["WebSMS.GeneralSettings.Units.BaseUnit"],
                    field: "BaseUnit.DisplayName",
                    template: "#if(data.BaseUnit != null){#<div>#=data.BaseUnit.DisplayName#</div>#}#"
                }
            ]
        }
        this.buttons = [
            {
                caption: Config.translations.newLabel,
                enabled: true,
                type: ToolBarStandardButtonType.NEW
            },
            {
                caption: Config.translations.editLabel,
                enabled: true,
                type: ToolBarStandardButtonType.EDIT
            },
            {
                caption: Config.translations.deleteLabel,
                enabled: true,
                type: ToolBarStandardButtonType.DELETE
            }
        ];
        Helper.getMetaData("editQuantity").then(result => {
            this.metaData = result;
        });
    }

    private createGrid = () => {
        const filter = Helper.hasValue(this.state.selectedEntity) ? this.state.selectedEntity.DisplayName : null;
        return (
            <Grid
                data={this.props.quantities}
                options={this.gridOptions}
                id="generalSettings_Unit_QuantitiesGrid"
                onSelectionChanged={this.onSelectionChange}
                standardButtons={this.buttons}
                onClickStandardButton={this.onButtonClick}
                preselectFilter={filter}
                selectFilter={filter}
            />
        );
    }

    private onButtonClick = (type: ToolBarStandardButtonType, dataItem: QuantityEntity) => {
        switch (type) {
            case ToolBarStandardButtonType.NEW:
                dataItem = UnitHelper.createEmptyEntity<QuantityEntity>();
                dataItem.BaseUnit = UnitHelper.createEmptyEntity<UnitEntity>()
                dataItem.Units = [];
                this.openSheet(dataItem, this.addNewQuantity);
                break;
            case ToolBarStandardButtonType.EDIT:
                if (!Helper.hasValue(dataItem.BaseUnit)) {
                    dataItem.BaseUnit = UnitHelper.createEmptyEntity<UnitEntity>();
                }
                this.openSheet(dataItem, this.saveExistingQuantity);
                break;
            case ToolBarStandardButtonType.DELETE:
                this.delete(dataItem);
                break;
        }
    }

    private addNewQuantity = async (entity: QuantityEntity) => {
        const result = await HTTPService.post<JsonResultClass<QuantityEntity>>("Unit/CreateQuantity", { model: entity })
        if (result.Code == 0) {
            NotificationHelper.showSuccessMessage(result.Message);
            const quantities = this.props.quantities;
            quantities.push(result.Data);
            this.props.updateQuantities(quantities, result.Data, () => {
                UnitHelper.selectDirty(result.Data.DisplayName);
            });
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
        return result.Code == 0;
    }

    private saveExistingQuantity = async (entity: QuantityEntity) => {
        const result = await HTTPService.post<JsonResultClass<QuantityEntity>>("Unit/UpdateQuantity", { model: entity })
        if (result.Code == 0) {
            NotificationHelper.showSuccessMessage(result.Message);
            const quantities = this.props.quantities;
            const index = quantities.findIndex(f => f.Id === result.Data.Id);
            if (index > -1) {
                quantities[index] = result.Data;
                
                this.setState({ selectedEntity: result.Data }, () => {
                    this.props.updateQuantities(quantities, result.Data, null);
                })
            } else {
                return false;
            }
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
        return result.Code == 0;
    }

    private delete = async (dataItem: QuantityEntity) => {
        const isOk = await DialogHelper.confirm(Config.translations.deleteMessage);
        if (isOk) {
            const result = await HTTPService.get<JsonResultClass>(`Unit/DeleteQuantity?id=${dataItem.Id}`);
            if (result.Code == 0) {
                NotificationHelper.showSuccessMessage(result.Message);
                let quantities = this.props.quantities.filter(f => f.Id !== dataItem.Id);
                this.setState({ selectedEntity: quantities.length > 0 ? quantities[0] : null }, () => {
                    this.props.updateQuantities(quantities, quantities.length > 0 ? quantities[0] : null, null);
                });
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        }
    }

    private openSheet = (dataItem: QuantityEntity, onSave: (entity: QuantityEntity) => Promise<boolean>) => {
        const props: EditQuantityProps = {
            context: {
                contextType: "Quantity"
            },
            dataSources: {
                units: dataItem.Units
            },
            entity: dataItem,
            isWindow: false,
            metadata: this.metaData,
            title: dataItem.DisplayName,
            onSave: onSave,
            translations: this.props.translations
        }
        const sheet = General.Sheet.Manager.createSheet();
        sheet.setTitle(Helper.getTranslation("WebSMS.GeneralSettings.Units.Quantity"));
        sheet.show(() => {
            sheet.mountContent(EditQuantity, props);
        })
    }

    private onSelectionChange = (dataItem: QuantityEntity) => {
        if (Helper.hasValue(dataItem)) {
            this.setState({ selectedEntity: dataItem }, () => {
                this.props.onSelectionChange(dataItem);
            })
        }
    }

    render() {
        return <div style={{ height: "600px" }}>{this.createGrid()}</div>;
    }
}

interface QuantityGridProps {
    translations: StringKeyDictionary<string>;
    quantities: QuantityEntity[];
    onSelectionChange: (entity: QuantityEntity) => void;
    updateQuantities: (quantities: QuantityEntity[], selected: QuantityEntity, callBack: () => void) => void;
}

interface QuantityGridState {
    selectedEntity: QuantityEntity;
}


class EditQuantity extends React.Component<EditQuantityProps, any>{
    common = new AppHelper();
    units: UnitEntity[];
    constructor(props: EditQuantityProps) {
        super(props)
        this.units = props.dataSources.units;
        this.common.enableHooks = false;
        this.common.init(this);
    }

    private validate = () => {
        let isOK = UnitHelper.containsAtLeastOneName(this.props.entity);
        if (!isOK) {
            NotificationHelper.showErrorMessage(this.props.translations["WebSMS.GeneralSettings.Documents.AtLeastOneName"]);
        }
        return isOK;
    }

    save = async () => {
        const isValid = this.validate();
        if (isValid) {
            const entity = this.props.entity;
            UnitHelper.setDisplayName(entity);
            UnitHelper.removeEmptyNames(entity)
            if (!Helper.hasValue(entity.BaseUnit) || Helper.isNullOrEmpty(entity.BaseUnit.Id) || entity.IsNew || (UnitHelper.findIndex(this.units, this.props.entity.BaseUnit.Id) == -1)) {
                entity.BaseUnit = null;
            }
            const isOk = await this.props.onSave(entity);
            this.common.handlePostSave(isOk, isOk);
        }
    }

    handleFieldChange = (field: { model: string }, value, dataItem = null, isInit = false) => {
        switch (field.model) {
            case "entity.BaseUnit.Id":
                this.handleFieldChange({ model: "entity.BaseUnit" }, dataItem)
                break;
        }
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    componentDidMount() {
        this.common.updateSheetTitle(this.props.title)
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} />;
    }
}

interface EditQuantityProps extends AppBaseProps {
    entity: QuantityEntity;
    translations: StringKeyDictionary<string>;
    onSave: (entity: QuantityEntity) => Promise<boolean>;
}


class UnitGrid extends React.Component<UnitGridProps, UnitGridState>{
    private gridOptions: kendo.ui.GridOptions;
    private buttons: Array<ToolBarStandardButton>;
    private changeBaseUnitId = "changeBaseId";
    private metaData: any;

    constructor(props: UnitGridProps) {
        super(props);
        let gridData: UnitEntity[] = [];
        if (Helper.hasValue(props.entity) && Helper.hasValue(props.entity.Units)) {
            gridData = props.entity.Units;
            for (let i = 0; i < gridData.length; i++) {
                gridData[i].IsBaseUnit = Helper.hasValue(props.entity.BaseUnit) && !Helper.isNullOrEmpty(props.entity.BaseUnit.Id) && (gridData[i].Id == props.entity.BaseUnit.Id)
            }
        }
        this.state = {
            gridData: gridData,
            quantity: JSON.parse(JSON.stringify(props.entity)),
            selected: gridData.length > 0 ? gridData[0] : null
        }
        this.initApp();
    }

    private initApp = () => {
        this.gridOptions = {
            sortable: true,
            pageable: false,
            groupable: false,
            filterable: true,
            selectable: true,
            resizable: true,
            scrollable: true,
            columns: [
                {
                    field: "IsBaseUnit",
                    title: "",
                    template: "#if(data.IsBaseUnit){#<span class='k-icon k-i-star-outline'></span>#}#",
                    width: 55,
                    filterable: false
                },
                {
                    field: "DisplayName",
                    title: this.props.translations["Standard.Name"]
                },
                {
                    field: "DisplayChars",
                    title: this.props.translations["WebSMS.GeneralSettings.Currency.Characters"]
                },
                {
                    field: "CommonCode",
                    title: this.props.translations["WebSMS.GeneralSettings.Units.CommonCode"]
                }
            ]
        };
        this.buttons = [
            {
                caption: Config.translations.newLabel,
                enabled: true,
                type: ToolBarStandardButtonType.NEW
            },
            {
                caption: Config.translations.editLabel,
                enabled: true,
                type: ToolBarStandardButtonType.EDIT
            },
            {
                caption: Config.translations.deleteLabel,
                enabled: true,
                type: ToolBarStandardButtonType.DELETE
            }
        ];
        Helper.getMetaData("editUnits").then(result => {
            this.metaData = result;
            this.setState({});
        });
    }

    private createGrid = () => {
        let customButtons = [
            {
                autoEnabledOnRecordSelected: true,
                caption: this.props.translations["WebSMS.GeneralSettings.Units.SetAsBaseUnit"],
                enabled: Helper.hasValue(this.state.selected) && !this.state.selected.IsBaseUnit,
                iconClass: "k-i-star-outline",
                id: this.changeBaseUnitId
            }
        ]
        const filter = Helper.hasValue(this.state.selected) ? this.state.selected.DisplayName : null;
        return (
            <Grid
                data={this.state.gridData}
                options={this.gridOptions}
                id="generalSettings_UnitsGrid"
                standardButtons={this.buttons}
                customButtons={customButtons}
                onClickStandardButton={this.onButtonClick}
                onClickCustomButton={this.onCustomButtonClick}
                preselectFilter={filter}
                selectFilter={filter}
                onSelectionChanged={this.onSelectionChange}
            />
        );
    }

    private onSelectionChange = (dataItem: UnitEntity) => {
        if (Helper.hasValue(dataItem)) {
            this.setState({ selected: dataItem })
        }
    }

    private onButtonClick = (type: ToolBarStandardButtonType, dataItem: UnitEntity) => {
        switch (type) {
            case ToolBarStandardButtonType.NEW:
                dataItem = UnitHelper.createEmptyEntity<UnitEntity>();
                dataItem.Chars = {};
                dataItem.DisplayChars = "";
                dataItem.CommonCode = "";
                dataItem.ExternalId = "";
                dataItem.IsBaseUnit = false
                this.openSheet(dataItem, this.addNewUnit)
                break;
            case ToolBarStandardButtonType.EDIT:
                this.openSheet(dataItem, this.saveExistingUnit);
                break;
            case ToolBarStandardButtonType.DELETE:
                this.delete(dataItem);
                break;
        }
    }

    private onCustomButtonClick = async (id: string, dataItem: UnitEntity) => {
        switch (id) {
            case this.changeBaseUnitId:
                this.setBaseUnit(dataItem);
                break;
        }
    }

    private setBaseUnit = async (dataItem: UnitEntity) => {
        const isOk = await DialogHelper.confirm(this.props.translations["WebSMS.GeneralSettings.Units.DefineAsBaseUnit"].replace("{unit}", dataItem.DisplayName))
        if (isOk) {
            const quantity = this.props.entity;
            const result = await HTTPService.get<JsonResultClass>(`Unit/UpdateBaseUnit?quantityId=${quantity.Id}&unitId=${dataItem.Id}`)
            if (result.Code == 0) {
                NotificationHelper.showSuccessMessage(result.Message);
                quantity.BaseUnit = dataItem;
                this.props.onChange(quantity, null);
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        }
    }

    private openSheet = (dataItem: UnitEntity, onSave: (entity: UnitEntity) => Promise<boolean>) => {
        const props: EditUnitProps = {
            context: {
                contextType: "unit",
                translations: this.props.translations
            },
            dataSources: {},
            entity: dataItem,
            isWindow: false,
            metadata: this.metaData,
            title: dataItem.IsNew ? this.props.translations["WebSMS.GeneralSettings.Units.NewUnitOf"].replace("{q}", this.props.entity.DisplayName) : `${dataItem.DisplayName} (${this.props.entity.DisplayName}) `,
            onSave: onSave,
            translations: this.props.translations,
            checkCommonCode: (entity: UnitEntity) => {
                return Helper.isNullOrEmpty(entity.CommonCode) || this.props.commonCodes.findIndex(f => !Helper.isNullOrEmpty(f) && f.toUpperCase() === entity.CommonCode.toUpperCase()) === -1;
            }
        }
        const sheet = General.Sheet.Manager.createSheet();
        sheet.show(() => {
            sheet.mountContent(EditUnit, props);
        })
    }

    private addNewUnit = async (entity: UnitEntity, saveAsBaseUnit: boolean = false) => {
        const result = await HTTPService.post<JsonResultClass<UnitEntity>>("Unit/CreateUnit", {
            model: entity,
            quantityId: this.props.entity.Id,
            useAsBaseUnit: saveAsBaseUnit
        })
        if (result.Code == 0) {
            const quantity = this.props.entity;
            result.Data.IsBaseUnit = entity.IsBaseUnit || saveAsBaseUnit;
            if (saveAsBaseUnit) {
                quantity.BaseUnit = result.Data;
            }
            if (!Helper.hasValue(quantity.Units)) {
                quantity.Units = [];
            }
            quantity.Units.push(result.Data);
            NotificationHelper.showSuccessMessage(result.Message);

            this.setState({ gridData: quantity.Units }, () => {
                this.props.onChange(quantity, null);
                UnitHelper.selectDirty(result.Data.DisplayName);
            })
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
        return result.Code == 0;
    }

    private saveExistingUnit = async (entity: UnitEntity) => {
        const result = await HTTPService.post<JsonResultClass<UnitEntity>>("Unit/UpdateUnit", { model: entity });
        if (result.Code == 0) {
            const quantity = this.props.entity;
            const index = UnitHelper.findIndex(quantity.Units, result.Data.Id);
            if (index > -1) {
                result.Data.IsBaseUnit = entity.IsBaseUnit;
                quantity.Units[index] = result.Data;
                NotificationHelper.showSuccessMessage(result.Message);
                this.props.onChange(quantity, null);
            } else {
                return false;
            }
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
        return result.Code == 0;
    }

    private delete = async (entity: UnitEntity) => {
        const dialogText = entity.IsBaseUnit ? this.props.translations["WebSMS.GeneralSettings.Units.ReallyDeleteBaseUnit"] : Config.translations.deleteMessage;
        const isOK = await DialogHelper.confirm(dialogText);
        if (isOK) {
            let requests: Promise<JsonResultClass>[]
            if (entity.IsBaseUnit) {
                requests = [
                    HTTPService.get<JsonResultClass>(`Unit/UpdateBaseUnit?quantityId=${this.props.entity.Id}`),
                    HTTPService.get<JsonResultClass>(`Unit/DeleteUnit?id=${entity.Id}`)
                ];
            } else {
                requests = [
                    HTTPService.get<JsonResultClass>(`Unit/DeleteUnit?id=${entity.Id}`)
                ];
            }
            const results = await Promise.all(requests);
            if (results.filter(f => f.Code == 1).length > 0) {
                results.filter(f => f.Code == 1).forEach((result) => {
                    NotificationHelper.showErrorMessage(result.Message)
                })
            } else {
                NotificationHelper.showSuccessMessage(this.props.translations["Standard.Msg.SpeichernErfolgreich"]);
                const quantity = this.props.entity;
                if (entity.IsBaseUnit) {
                    quantity.BaseUnit = null;
                }
                quantity.Units = quantity.Units.filter(f => f.Id !== entity.Id);
                this.setState({ gridData: quantity.Units }, () => {
                    this.props.onChange(quantity, null);
                })
            }
        }
    }

    componentDidUpdate() {
        if ((this.state.quantity.Id !== this.props.entity.Id)) {
            this.quantityChanged(this.props.entity)
        } else if (JSON.stringify(this.state.quantity.BaseUnit) !== JSON.stringify(this.props.entity.BaseUnit)) {
            this.setState({ quantity: this.props.entity }, () => {
                this.baseUnitChanged(Helper.hasValue(this.props.entity.BaseUnit) ? this.props.entity.BaseUnit.Id : null)
            })
        }
    }

    private quantityChanged = (newQuantity: QuantityEntity) => {
        let gridData: UnitEntity[] = Helper.getValueOrDefault(newQuantity.Units, []);
        for (let i = 0; i < gridData.length; i++) {
            gridData[i].IsBaseUnit = Helper.hasValue(newQuantity.BaseUnit) && !Helper.isNullOrEmpty(newQuantity.BaseUnit.Id) && (gridData[i].Id == newQuantity.BaseUnit.Id)
        }
        const selected = gridData.length > 0 ? gridData[0] : null;
        this.setState({
            gridData: gridData,
            quantity: JSON.parse(JSON.stringify(newQuantity)),
            selected: selected
        }, () => {
            if (Helper.hasValue(selected))
                UnitHelper.selectDirty(selected.DisplayName);
        })
    }

    private baseUnitChanged = (baseUnitId: string) => {
        let gridData = this.state.gridData;
        for (let i = 0; i < gridData.length; i++) {
            gridData[i].IsBaseUnit = !Helper.isNullOrEmpty(baseUnitId) && (gridData[i].Id == baseUnitId)
        }
        this.setState({ gridData: gridData })
    }

    render() {
        return this.createGrid();
    }
}

interface UnitGridProps {
    entity: QuantityEntity;
    translations: StringKeyDictionary<string>;
    onChange: (entity: QuantityEntity, callBack: () => void) => void;
    commonCodes: string[];
}

interface UnitGridState {
    gridData: UnitEntity[];
    quantity: QuantityEntity;
    selected: UnitEntity;
}


class EditUnit extends React.Component<EditUnitProps, any>{
    common = new AppHelper();
    private initCommonCode: string;
    private inCommonCodeChange: boolean = false;
    private syncExternalId: boolean = true;
    constructor(props: EditUnitProps) {
        super(props)
        console.log(props)
        this.initCommonCode = JSON.parse(JSON.stringify(props.entity.CommonCode))
        this.common.enableHooks = false;
        this.common.init(this);
    }

    private validate = () => {
        let result = true;
        let isOK = UnitHelper.containsAtLeastOneName(this.props.entity);
        if (!isOK) {
            NotificationHelper.showErrorMessage(this.props.translations["WebSMS.GeneralSettings.Documents.AtLeastOneName"]);
            result = false;
        }

        isOK = UnitHelper.containsAtLeastOneCharSet(this.props.entity);
        if (!isOK) {
            NotificationHelper.showErrorMessage(Helper.getTranslation("WebSMS.GeneralSettings.Units.AtLeastOneCahr"));
            result = false;
        }

        isOK = (this.initCommonCode === this.props.entity.CommonCode) || this.props.checkCommonCode(this.props.entity);
        if (!isOK) {
            NotificationHelper.showErrorMessage(this.props.translations["WebSMS.GeneralSettings.Units.CommonCodeUnique"]);
            result = false;
        }
        return result;
    }

    private setDisplayChars = () => {
        let displayChars: string = this.props.entity.Chars[Config.user.languageCode];
        if (Helper.isNullOrEmpty(displayChars)) {
            const keys = Object.keys(this.props.entity.Chars).filter(f => f !== "_events" && f !== "_handlers" && f !== "uid" && f !== "parent");
            const index = keys.findIndex(f => f.includes("en"));
            if (index > -1 && !Helper.isNullOrEmpty(this.props.entity.Chars[keys[index]])) {
                displayChars = this.props.entity.Chars[keys[index]];
            } else if (keys.length > 0 && !Helper.isNullOrEmpty(this.props.entity.Chars[keys[0]])) {
                displayChars = this.props.entity.Chars[keys[0]];
            }
        }
        this.props.entity.DisplayChars = displayChars;
    }

    save = async (saveAsBaseUnit: boolean = false) => {
        const isValid = this.validate();
        if (isValid) {
            UnitHelper.setDisplayName(this.props.entity);
            UnitHelper.removeEmptyNames(this.props.entity);
            this.setDisplayChars();
            const isOk = await this.props.onSave(this.props.entity, saveAsBaseUnit);
            this.common.handlePostSave(isOk, isOk);
        }
    }

    handleFieldChange = (field: { model: string }, value, dataItem = null, isInit = false) => {
        switch (field.model) {
            case "entity.CommonCode":
                value = (value as string).toUpperCase();
                if (this.props.entity.IsNew && this.syncExternalId) {
                    this.inCommonCodeChange = true;
                    this.handleFieldChange({ model: "entity.ExternalId" }, value);
                    this.inCommonCodeChange = false;
                }
                break;
            case "entity.ExternalId":
                if (!this.inCommonCodeChange)
                    this.syncExternalId = false;
                break;
        }
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    componentDidMount() {
        this.common.updateSheetTitle(this.props.title)
        if (this.props.entity.IsBaseUnit) {
            const titleElements = document.getElementsByClassName("sheet__title__label__text");
            if (titleElements.length > 1) {
                const titleElement = titleElements[1] as HTMLElement;
                const span = document.createElement("span")
                span.className = "k-icon k-i-star-outline"
                titleElement.appendChild(span)
            }
        }
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} />;
    }
}

interface EditUnitProps extends AppBaseProps {
    entity: UnitEntity;
    translations: StringKeyDictionary<string>;
    onSave: (entity: UnitEntity, saveAsBaseUnit: boolean) => Promise<boolean>;
    checkCommonCode: (entity: UnitEntity) => boolean;
    context: UnitContext;
}


interface UnitContext extends Context {
    translations: StringKeyDictionary<string>
}


class UnitHelper {
    public static containsAtLeastOneName = (entity: BaseUnitEntity) => {
        let result = false;
        Object.keys(entity.Name).forEach((key: string) => {
            result ||= !Helper.isNullOrEmpty(entity.Name[key])
        });
        return result;
    }

    public static containsAtLeastOneCharSet = (entity: UnitEntity) => {
        let result = false;
        Object.keys(entity.Chars).forEach((key: string) => {
            result ||= !Helper.isNullOrEmpty(entity.Chars[key])
        });
        return result;
    }

    public static setDisplayName = (entity: BaseUnitEntity) => {
        let displayName: string = entity.Name[Config.user.languageCode];
        if (Helper.isNullOrEmpty(displayName)) {
            const keys = Object.keys(entity.Name).filter(f => f !== "_events" && f !== "_handlers" && f !== "uid" && f !== "parent");
            const index = keys.findIndex(f => f.includes("en"));
            if (index > -1) {
                displayName = entity.Name[keys[index]];
            } else if (keys.length > 0) {
                displayName = entity.Name[keys[0]];
            }
        }
        entity.DisplayName = displayName;
    }

    public static removeEmptyNames = (entity: BaseUnitEntity) => {
        Object.keys(entity.Name).forEach((key: string) => {
            if (Helper.isNullOrEmpty(entity.Name[key])) {
                delete entity.Name[key];
            }
        });
    }

    public static createEmptyEntity = <T extends BaseUnitEntity>() => {
        const entity: BaseUnitEntity = {
            DisplayName: "",
            Id: kendo.guid(),
            IsNew: true,
            IsWatchable: false,
            IsWatched: false,
            Name: {},
            RecordRight: {
                CanRead: true,
                CanWrite: true
            },
            IndividualFields: {}
        }
        return entity as T;
    }

    public static findIndex = (data: BaseUnitEntity[], id: string) => {
        for (let i = 0; i < data.length; i++) {
            if (data[i].Id === id) {
                return i;
            }
        }
        return -1;
    }

    public static sortByDisplayName = <T extends BaseUnitEntity>(data: T[]) => {
        data = data.sort((a, b) => {
            if (a.DisplayName < b.DisplayName) {
                return -1;
            }
            if (a.DisplayName > b.DisplayName) {
                return 1;
            }
            return 0;
        })
        return JSON.parse(JSON.stringify(data));
    }

    //I dont know what i want, but i know how to get it
    public static selectDirty = (name: string) => {
        const xpath = `//td[text()='${name}']`;
        const matchingElement = document.evaluate(xpath, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue as HTMLElement
        if (Helper.hasValue(matchingElement))
            matchingElement.click()
    }
}

export interface QuantityEntity extends BaseUnitEntity {
    BaseUnit: UnitEntity;
    Units: UnitEntity[];
}

export interface UnitEntity extends BaseUnitEntity {
    Chars: {};
    DisplayChars: string;
    CommonCode: string;
    ExternalId: string;
    IsBaseUnit?: boolean;
}

interface BaseUnitEntity extends Entity {
    Id: string;
    Name: {};
    DisplayName: string;
}